import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import * as ApiService from '../services';

const createFuelEntry = ({
  body,
}: {
  body: any;
}) => ApiService.createFuelEntry({body});

const useMutationCreateFuelEntry = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}) => {
  const queryClient = useQueryClient();
  const { mutate, data, isPending } = useMutation({
    mutationFn: createFuelEntry,
    onError,
    onSuccess: () => {
      // The list page reads these caches — refresh so the new entry shows up
      queryClient.invalidateQueries({ queryKey: ['getFuelEntries'] });
      queryClient.invalidateQueries({ queryKey: ['getFuelStores'] });
      queryClient.invalidateQueries({ queryKey: ['getStoreFuelEntries'] });
      queryClient.invalidateQueries({ queryKey: ['getVehicles'] });
      onSuccess?.();
    },
  });
  return {
    mutate,
    data,
    isPending,
  };
};

export default useMutationCreateFuelEntry;
